export default "__VITE_ASSET__C3T6b04i__"